export default __webpack_public_path__ + "static/media/times-solid.0c3c9dbb.svg";